export function iDB(config) {

  let _this = {};
  let _db = null;

  // Configuration
  const _dbName = config ? config.name : 'grip3';
  const _dbVersion = config ? config.version : 20;
  const _storeName = config ? config.store : 'keyval';

  
  _this.open = function () {
    /**
     * Open the IndexedDB using the config db name and obj store.
     * 
     * @promised: if done calls it with { success: true }, otherwise 
     * calls it with { success: false, error: descripcion }
     */
    return (new Promise((resolve, reject) => {

      console.log('iDB open() connect db='+_dbName+', store='+_storeName);

      if (_db) {
        resolve();
        return;
      }

      var request = indexedDB.open(_dbName, _dbVersion);
  
      request.onerror = function (e) {
        console.log('iDB open() error=', e.target.error);
        reject(e.target.error)
      };
  
      request.onblocked = function (e) {
        console.log('iDB open() blocked=', e.target.error);
        reject(e.target.error)
      }
  
      request.onupgradeneeded = function (e) {
        console.log('iDB open() request UPGRADENEEDED=', e);
        _db = e.target.result;
        try {
          var objectStore = _db.createObjectStore(_storeName);
        }
        catch (err) {
          console.log('ObjectStore alreay exists ?', err)
        }
        resolve();
      };
  
      request.onsuccess = function (e) {
        console.log('iDB open() request SUCCESS=', e.target.result);
        _db = e.target.result;
        resolve();
      }

    }));
  }


  _this.ready = function () {
    return(_db !== null);
  }


  _this.clear = function() {
    /**
     * Clears all the object stores in this DB.
     */
    return (new Promise(function(resolve, reject) {

      try {
        var transaction = _db.transaction([_storeName], "readwrite");
        var store = transaction.objectStore(_storeName);
        var request = store.clear();

        request.onsuccess = function(e) {
          console.log('iDB clear() request SUCCESS=', e);
          _db = null;
          // we dont resolve here, because we will resolve 
          // when the transaction really completes 
        };    
        
        transaction.oncomplete = function (e) {
          console.log('iDB clear() transaction COMPLETED=', e);
          _db = null;
          resolve({
            success: true,
            status: e
          })
        }

        transaction.onabort = function (e) {
          console.log('iDB clear() transaction ABORTED='+e.target.error);
          reject({
            success: false,
            error: e.target.error
          })
        }
        
        transaction.onerror = function (e) {
          console.log('iDB clear() transaction ERROR='+e.target.error);
          reject({
            success: false,
            error: e.target.error
          })
        }
      }
      catch (err) {
        console.log('iDB clear() CATCH=', err);
        reject({
          success: false,
          error: err
        })
      }  

    }))
  }


  _this.remove = function(key) {
    /**
     * Removes the obj with @key from the object store.
     * 
     * @key: a valid object key.
     * 
     * @promised: if done calls it with { success: true }, otherwise 
     * calls it with { success: false, error: descripcion }
     */
    return (new Promise((resolve, reject) => {

      if (!key) {
        console.log("iDB remove() error= Undefined key!")
        reject({
          success: false,
          error: "Invalid params: undefined key."
        })
      }
  
      try {
        var transaction = _db.transaction([_storeName], "readwrite");
        var store = transaction.objectStore(_storeName);
        var request = store.delete(key);
  
        request.onsuccess = function(e) {
          console.log('iDB remove() request SUCCESS=', e);
          // we dont resolve here, because we will resolve 
          // when the transaction really completes 
        };    

        transaction.oncomplete = function (e) {
          console.log('iDB remove() transaction COMPLETED=', e);
          resolve({
            success: true
          })
        }

        transaction.onabort = function (e) {
          console.log('iDB remove() transaction ABORTED=', e);
          reject({
            success: false,
            error: e.target.error
          })
        }
        
        transaction.onerror = function (e) {
          console.log('iDB remove() transaction ERROR=', e);
          reject({
            success: false,
            error: e.target.error
          })
        }
      }
  
      catch (err) {
        console.log('iDB remove() CATCH=', err);
        reject({
          success: false,
          error: err.toString()
        })
      }  
  
    }))
  }


  _this.get = function (key) {
    /**
     * Gets the obj with @key from the object store.
     * 
     * @key: a valid object key.
     * 
     * @promised: if done calls it with { success: true, value: ... }, otherwise 
     * calls it with { success: false, error: descripcion }
     */
    return (new Promise((resolve, reject) => {

      if (!key) {
        console.log("iDB get() error= Undefined key!")
        resolve({
          success: false,
          error: "Invalid params: undefined key."
        })
      }
  
      try {
        var transaction = _db.transaction([_storeName]); // is read-only 
        var store = transaction.objectStore(_storeName);
        var request = store.get(key);

        request.onsuccess = function(e) {
          // Do something with the request.result!
          if (request.result) {
            console.log('iDB get() request "'+key+'" SUCCESS=', e);
            resolve({ 
              success: true,  
              value: request.result 
            })
          }
          else {
            console.log('iDB get() request "'+key+'" FAILED=', e);
            resolve({
              success: false,  
              value: null, 
              error: 'Key does not exist in iDB !' 
            })
          }
        }
        
        request.onerror = function(e) {
          console.log('iDB get() request "'+key+'" ERROR=', e);
          resolve({
            success: false,
            error: e.target.error
          })
        }
      }
      catch (err) {
        console.log('iDB get() CATCH=', err);
        resolve({
          success: false,
          error: err.toString()
        })
      }
 
    }))
  }


  _this.put = function (key, data) {

    return (new Promise((resolve, reject) => {

      if (!key || !data) {
        console.log("iDB put() error= Undefined key or data !")
        reject({
          success: false,
          error: "Invalid params: undefined key or data."
        })
      }
      
      try {
        var transaction = _db.transaction([_storeName], "readwrite");
        var store = transaction.objectStore(_storeName);
        var request = store.put(data, key);
        
        request.onsuccess = function(e) {
          console.log('iDB put() request "'+key+'" SUCCESS=', e);
          // we dont resolve here, because we will resolve 
          // when the transaction really completes 
        };    

        transaction.oncomplete = function (e) {
          console.log('iDB put()  "'+key+'" transaction COMPLETED=', e);
          resolve({
            success: true,
            status: e.toString()
          })
        }

        transaction.onabort = function (e) {
          console.log('iDB put()  "'+key+'" transaction ABORTED=', e);
          console.log('key, data len, typeof', key, data.length, typeof(data))
          resolve({
            success: false,
            error: e.target.error
          })
        }
        
        transaction.onerror = function (e) {
          console.log('iDB put()  "'+key+'" transaction ERROR=', e);
          resolve({
            success: false,
            error: e.target.error
          })
        }
      } 
      catch (err) {
        console.log('iDB put() CATCH=', err);
        resolve({
          success: false,
          error: err.toString()
        })
      }

    }))  
  }
  
  return _this;
}
